import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useLocation } from "react-router-dom";
import { ETSY_SHOP_URL } from "@/data/products";

/**
 * StickyShopCTA — always-visible floating "Shop Etsy" pill.
 * Appears after the user scrolls past the hero fold, on every page.
 * Sits above the fold on mobile bottom-right; desktop mid-right.
 */
export default function StickyShopCTA() {
  const [visible, setVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => {
      const trigger = window.innerHeight * 0.6;
      setVisible(window.scrollY > trigger);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [location.pathname]);

  return (
    <AnimatePresence>
      {visible && (
        <motion.a
          key="sticky-etsy"
          href={ETSY_SHOP_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="sticky-shop-cta"
          initial={{ opacity: 0, y: 40, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 40, scale: 0.9 }}
          transition={{ duration: 0.45, ease: [0.19, 1, 0.22, 1] }}
          whileHover={{ scale: 1.04 }}
          whileTap={{ scale: 0.96 }}
          className="fixed z-40 bottom-5 right-5 md:bottom-8 md:right-8 inline-flex items-center gap-3 bg-[#8a4a33] hover:bg-[#a05a3f] text-[#f5ebd8] px-5 py-3.5 md:px-6 md:py-4 border border-[#c28b46]/60 shadow-[0_20px_60px_-15px_rgba(198,40,40,0.5),0_10px_40px_-10px_rgba(0,0,0,0.7)] text-[11px] md:text-[12px] tracking-[0.24em] uppercase font-semibold"
          aria-label="Shop Earth Tone Original Skin on Etsy"
        >
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#c28b46] opacity-60" />
            <span className="relative inline-flex rounded-full h-2 w-2 bg-[#c28b46]" />
          </span>
          <span>Shop Etsy</span>
          <span aria-hidden className="text-[14px] md:text-[16px] leading-none">
            →
          </span>
        </motion.a>
      )}
    </AnimatePresence>
  );
}
